import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

// PrimeNG imports
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

export interface SuccessDialogData {
  title: string;
  message: string;
  buttonLabel?: string;
}

@Component({
  selector: 'app-success-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonModule],
  template: `
    <div class="flex flex-col items-center gap-6 p-6">
      <!-- Icon and Title -->
      <div class="flex flex-col items-center gap-3">
        <i class="pi pi-check-circle text-green-500 text-5xl"></i>
        <h2 class="text-xl font-semibold text-center m-0">{{ data.title }}</h2>
      </div>

      <!-- Message -->
      <p class="text-center text-gray-400 leading-6">
        {{ data.message }}
      </p>

      <!-- OK Button -->
      <div class="flex flex-col w-full items-end">
        <p-button
          [label]="data.buttonLabel || ('common.ok' | translate)"
          (onClick)="close()"
          autofocus
        >
        </p-button>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        min-width: 300px;
        max-width: 400px;
      }
    `,
  ],
})
export class SuccessDialogComponent {
  data: SuccessDialogData;

  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) {
    this.data = this.config.data;
  }

  close(): void {
    this.ref.close();
  }
}
